import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AgentService } from '../../../../../services/agent.service';
import { AppService } from '../../../../../core/app.service';
import { StructureService } from '../../../../../services/StructureService';
import { SelectOption } from '../../../../../data/schemas/selectoption.schema';
import { StructureResponse } from '../../../../../data/http/responses/strcuture.res';
import { PosteRes } from '../../../../../data/http/responses/poste.res';
import { LoaderComponent } from "../../../../../components/ui/loader/loader.component";
import { SelectComponent } from "../../../../../components/forms/select/select.component";
import { sexeData } from '../../../../../data/schemas/data/sexe.schema';
import { Input } from '../../../../../components/forms/input/input';
import { PosteService } from '../../../../../services/poste.service';
import { Router } from '@angular/router';
import { routeAlias } from '../../../../../../routesalias';
import { UiButtonComponent } from '../../../../../components/button/button.component';
import { RouterLink } from '@angular/router';


@Component({
  selector: 'app-add',
  imports: [ReactiveFormsModule, LoaderComponent, SelectComponent, Input,UiButtonComponent, RouterLink],
  templateUrl: './add.component.html',
  styleUrl: './add.component.css'
})
export class AddAgentPage implements OnInit {
  entityForm!: FormGroup;
  public isLoading: boolean = false;
  public structures: SelectOption[] = [];
  public postes: SelectOption[] = [];
  public sexes: SelectOption[] = [];
  public routeAlias = routeAlias;

  constructor(
    private entityService: AgentService,
    private posteService: PosteService,
    private structureService: StructureService,
    private fb: FormBuilder,
    private AppService: AppService,
    private router: Router
  ){
    this.sexes = sexeData.map((sexe) => ({
      value: sexe.code,
      label: sexe.label
    }))

    this.entityForm = this.fb.group({
      applicationId: this.AppService.getAppId()!,
      strucutre : ['', [Validators.required]],
      poste : ['', [Validators.required]],
      nom : ['', [Validators.required]],
      prenoms : ['', [Validators.required]],
      sexe : [''],
      email : [''],
      adresse : [''],
      telephone : [''],
      emailPro : [''],
      dateNaissance: [''],
      datePriseService: [''],
    });
  }

  ngOnInit(): void {
    this.loadStructures()
    this.loadPostes()
  }

  loadStructures(): void {
    this.isLoading = true
    this.structureService.getAllByAppId(this.AppService.getAppId()).subscribe({
      next: (response: any) => {
        this.structures = response.data.map((item: StructureResponse) => ({
          value: item.id,
          label: item?.libelle
        }));
        this.isLoading =false
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
        this.isLoading =false
      }
    });
  }

  loadPostes(): void {
    this.posteService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.postes = response.data.map((item: PosteRes) => ({
          value: item.id,
          label: item?.libelle
        }));
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

  onSubmitEntity(): void{
    if (this.entityForm.valid) {
      this.isLoading = true;
      this.entityService.create(this.entityForm.value).subscribe({
        next: (createdStructure) => {
          this.router.navigate([
            routeAlias.administration.home,
            routeAlias.administration.agent.home,
          ]);
          this.isLoading = false
        },
        error: (error) => {
          console.error('Erreur lors de la création de la structure programmatique :', error);
          this.isLoading = false
        }
      });
    }else {
      console.warn('Le nom de la structure programmatique ne peut pas être vide.');
    }
  }
}
